<template>
  <keep-alive>
    <div class="wrap-action-list">
      <div class="response_table">
        <table>
          <thead
            ref="tableHead"
            class="table-action-list_bg"
          >
            <tr>
              <th scope="col"> {{ translate('sim_task_list.action_list.action_name') }} </th>
              <th scope="col"> {{ translate('sim_task_list.action_list.device') }} </th>
              <th scope="col"> {{ translate('sim_task_list.action_list.iccid') }} </th>
              <th scope="col"> {{ translate('sim_task_list.action_list.imsi') }} </th>
              <th scope="col"> {{ translate('sim_task_list.action_list.msisdn') }} </th>
              <th scope="col"> {{ translate('sim_task_list.action_list.status') }} </th>
              <th scope="col"> {{ translate('sim_task_list.action_list.user') }} </th>
              <th scope="col"> {{ translate('sim_task_list.action_list.task_id') }} </th>
              <th scope="col"> {{ translate('sim_task_list.action_list.ts_created') }} </th>
              <th scope="col"> {{ translate('sim_task_list.action_list.ts_updated') }} </th>
            </tr>
          </thead>

          <tbody ref="tableSimcard">
            <tr v-if="load">
              <td> <scale-loader /> </td>
            </tr>

            <tr
                class="action_item"
                v-for="(action, key) in action_list"
                :key="key"
            >
              <td :data-label="translate('sim_task_list.action_list.action_name')">
                {{ action.action_name }}
              </td>
              <td :data-label="translate('sim_task_list.action_list.action_name')">
                <router-link :to="{path: '/device/' + action.device_fid}">
                  {{ action.device_fid }}
                </router-link>
                <p>
                  {{ action.device_name }}
                </p>
              </td>

              <td :data-label="translate('sim_task_list.action_list.iccid')">
                <router-link :to="{path: '/device_list?&universal_search=' + action.iccid}">
                  {{ action.iccid }}
                </router-link>
              </td>

              <td :data-label="translate('sim_task_list.action_list.imsi')">
                {{ action.imsi }}
              </td>

              <td :data-label="translate('sim_task_list.action_list.msisdn')">
                {{ action.msisdn }}
              </td>

              <td :data-label="translate('sim_task_list.action_list.status')">
                {{ action.status_text }}
              </td>

              <td :data-label="translate('sim_task_list.action_list.user')">
                {{ action.user_name }}
              </td>

              <td :data-label="translate('sim_task_list.action_list.task_id')">
                {{ action.task_id }}
              </td>

              <td :data-label="translate('sim_task_list.action_list.ts_created')">
                {{ get_date(action.ts_create) }}
              </td>

              <td :data-label="translate('sim_task_list.action_list.ts_updated')">
                {{ get_date(action.ts_update) }}
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </keep-alive>
</template>
<script>


export default {
  name: 'ActionList',
  components: {
  },
  data () {
    return {
      load: true,
      action_list: []
    }
  },

  created () {
    this.load_action_list()
  },

  methods: {
    load_action_list(){
      this.load = true
      this.$http.simcard.getSimcardProfileAction({}, (response) => {
        if (response.data){
          this.load = false
          this.action_list = response.data.items
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.wrap-action-list{
  display: flex;
  flex-direction: column;
  height: 100%;
  .response_table{
    padding: 0;
    .action_item{
      cursor: pointer;
      &:hover{
        background-color: #eee;
      }
    }
  }
}

</style>
